.dashboardJoinForm {
  display: flex;
  flex-flow: row nowrap;
  align-items: flex-end;
  margin-bottom: 20px;

  & .gameIdInputWrapper {
    width: 250px;
  }

  & .joinButton {
    margin: 0 12px;
  }
}

.createButton {
  margin-top: 40px;
}

.dashboardWrapper {
  margin: 12px 20px;
  display: flex;
  justify-content: flex-start;
}

.activeGameListWrapper {
  border-radius: 12px;
  border: 1px solid var(--ds-grey-dark);
  padding: 8px 12px;
  display: flex;
  flex-flow: column nowrap;
  max-width: max-content;
}

.activeGameListHeader {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 6px;
}

.activeGameListToggle {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
}

.activeGameList {
  margin-top: 8px;
  display: grid;
  grid-template-columns: 80px minmax(300px, max-content) 37px 80px;
  grid-auto-flow: row;

  max-height: 350px;
  overflow: scroll;
  max-width: max-content;

  & b {
    font-weight: 600;
  }

  & > * {
    padding: 2px;
  }

  & .activeGameListTrashIcon {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    padding-right: 20px;
  }

  & > :nth-child(8n - 3),
  & > :nth-child(8n - 2),
  & > :nth-child(8n - 1),
  & > :nth-child(8n - 0) {
    background-color: var(--ds-off-white);
  }
}

.leftHalf,
.rightHalf {
  flex-grow: 1;
}

.rankingsWrapper {
  margin-top: 4px;

  display: grid;
  grid-template-columns: auto 80px auto;
  grid-auto-flow: row;

  max-width: 50%;

  & > :nth-child(6n - 0),
  & > :nth-child(6n - 1),
  & > :nth-child(6n - 2) {
    background-color: var(--ds-off-white);
  }
}

.rankingsHeader {
  cursor: pointer;
  color: var(--ds-grey-medium);
  &:hover {
    color: var(--ds-black);
  }
}
